import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Observable } from 'rxjs';
import { MatDialog} from '@angular/material/dialog';
import { BankPortalService } from '../../web-api-client';
import * as moment from 'moment';


@Component({
  selector: 'app-merchant-rollRequest',
  templateUrl: './merchantRollRequest.component.html'
})
export class MerchantRollRequestComponent implements OnInit {
  rows:any[] = [];
  array1 = [];
  columnDefs: any[] = [];
    columns: any[] = [];
    rowsCache:any[] = [];
    showModelBox: boolean = false;
  constructor(private formBuilder: UntypedFormBuilder, public dialog: MatDialog, private bankPortalService : BankPortalService) { }

  ngOnInit() {

    this.columnDefs = [
      //{ headerName: 'Bank Name', field: 'bankName', width: 250, suppressSizeToFit: true },
      { headerName: 'Merchant Name', field: 'merchant_name', width: 300, suppressSizeToFit: true },

      { headerName: 'Termnal Id', field: 'tid', width: 200, suppressSizeToFit: true },
      //{ headerName: 'Merchant  Id', field: 'mid', width: 200, suppressSizeToFit: true },
      { headerName: 'Pos Type', field: 'pos_title', width: 250, suppressSizeToFit: true },
      //{ headerName: 'Serial Number', field: 'pos_serial', width: 200, suppressSizeToFit: true },
      //{ headerName: 'Mobile Number', field: 'mobile_number', width: 200, suppressSizeToFit: true },
      { headerName: 'Requested Roll', field: 'requested_roll', width: 200, suppressSizeToFit: true },
      { headerName: 'Pending Roll', field: 'pending_roll', width: 200, suppressSizeToFit: true },
      { headerName: 'Status', field: 'status', width: 200, suppressSizeToFit: true },
      //{ headerName: 'Created Date', field: 'created_at', width: 200, suppressSizeToFit: true },
      {headerName: 'Requested Date', field: 'created_at', valueFormatter: (data) => moment(data.value).format('ll'), width: 128, suppressSizeToFit: true, filter: 'date',
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            //using moment js
            var dateAsString = moment(cellValue).format('DD/MM/YYYY');
            var dateParts = dateAsString.split("/");
            var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          }
        }
      },
  ];
    this.loadMerchantSupportData();
  }
  loadMerchantSupportData() {
    //this.inventory.hasSerialNo = true;
    // this.bankPortalService.getMerchantRollRequests().subscribe(results => this.onDataLoadSuccessful(results), error => this.onDataLoadFailed(error));
}
onDataLoadSuccessful(supports: any) {

    this.rows = supports.data;
    this.rowsCache = supports.data;
}
onDataLoadFailed(error: any) {


}
onSearchChanged(value: string) {
  // this.rows = this.rowsCache.filter(r => Utilities.searchArray(value, false,  r.merchant_name, r.tid));
}

gridOptions = {
  rowSelection: 'multiple',
  enableSorting: 'true',
  enableColResize: 'true',
  enableRtl: 'true',
  pagination: 'true',
  paginationAutoPageSize: 'true',
  animateRows: 'true',
  rowClicked:'true'
}



}
